export default "{{title}}";